export enum ClinicalActivityStatusText {
  Upcoming = "Upcoming",
  Overdue = "Overdue",
  Today = "Due today",
  Completed = "Completed",
  NoResponse = "No response",
  Declined = "Declined",
  NoLongerRequired = "No longer required"
}
